import "../calculator//calculator.sass";
import NumberFormat from "react-number-format";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { CalculatorRow } from "../calculator/calculator";
import { NOT_AVAILABLE } from "../shared/constants";
import { isFinite } from "lodash";

const headers = ["Year", "Fiscal Year", "FCF", "Present Value of FCF"];

export default function CalculatorTable(props: {
  rows: CalculatorRow[];
  discount: number;
  exitMultipleSum: number;
  discountedPresentValue: number;
  presentValueSum: number;
  presentValueSumCash: number;
  cash: number;
  valuePerShare: string | number;
  intrinsicValuePerShare: string | number;
}) {
  const {
    rows,
    discount,
    exitMultipleSum,
    discountedPresentValue,
    presentValueSum,
    presentValueSumCash,
    cash,
    valuePerShare,
    intrinsicValuePerShare,
  } = props;
  return (
    <Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, i) => (
                <TableCell align="right" key={i} colSpan={1}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow
                key={row.year}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="right">
                  {row.year}
                </TableCell>
                <TableCell align="right">{row.fiscalYear}</TableCell>
                <TableCell align="right">
                  <NumberFormat
                    value={row.fcf}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={2}
                  ></NumberFormat>
                </TableCell>
                <TableCell align="right">
                  <NumberFormat
                    value={row.pvFcf}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={2}
                  ></NumberFormat>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell align="right">{rows[rows.length - 1].year}</TableCell>
              <TableCell align="right">FCF * Exit Multiple</TableCell>
              <TableCell align="right">
                <NumberFormat
                  value={exitMultipleSum}
                  displayType="text"
                  thousandSeparator={true}
                  decimalScale={2}
                ></NumberFormat>
              </TableCell>
              <TableCell colSpan={3} align="right">
                <NumberFormat
                  value={discountedPresentValue}
                  displayType="text"
                  thousandSeparator={true}
                  decimalScale={2}
                ></NumberFormat>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} align="right">
                PV of FCF + Cash in {rows[0].fiscalYear} (
                {
                  <NumberFormat
                    value={presentValueSum}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={2}
                  ></NumberFormat>
                }{" "}
                +{" "}
                {
                  <NumberFormat
                    value={cash}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={2}
                  ></NumberFormat>
                }
                )
              </TableCell>
              <TableCell colSpan={3} align="right">
                <NumberFormat
                  value={presentValueSumCash}
                  displayType="text"
                  thousandSeparator={true}
                  decimalScale={2}
                ></NumberFormat>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right">Share Price</TableCell>
              <TableCell align="right">
                {Number.isFinite(valuePerShare) ? (
                  <NumberFormat
                    value={valuePerShare}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={2}
                  ></NumberFormat>
                ) : (
                  NOT_AVAILABLE
                )}
              </TableCell>
              <TableCell align="right">Intrinsic Value Per Share</TableCell>
              <TableCell align="right">
                {Number.isFinite(intrinsicValuePerShare) ? (
                  <NumberFormat
                    value={intrinsicValuePerShare}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={2}
                  ></NumberFormat>
                ) : (
                  NOT_AVAILABLE
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3} align="right">
                {!isFinite(discount) || discount >= 0 ? "Discount" : "Premium"}{" "}
                to Intrinsic Value
              </TableCell>
              <TableCell
                colSpan={3}
                align="right"
                className={
                  isFinite(discount) ? (discount >= 0 ? "green" : "red") : ""
                }
              >
                {isFinite(discount) && (
                  <NumberFormat
                    value={discount}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={2}
                  ></NumberFormat>
                )}
                {isFinite(discount) ? "%" : NOT_AVAILABLE}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
